import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { AffiliateLink } from "../../utils/types/affiliate_link";
import { specification, dataType, fieldData } from "../../utils/types/tag";
import { vignettePreview_template } from "./vignettePreview_template";
import {
  SPEC_TYPE_TEXT,
  SPEC_TYPE_DATE,
  SPEC_TYPE_TAG,
  SPEC_TYPE_TAGS,
} from "../../utils/consts/tag_spec_type";
import { streamRentBuyFilter } from "../../utils/AffiliateLinkHelper";
import { userCanEditOwnedTagType } from "../../utils/PermissionsHelper";
import { emaki_brand } from "../../utils/types/emaki_brand";
import TagDefaultsHelper from "../../utils/TagDefaultsHelper";

declare var ko: any;

export class tagsView_template extends vnTemplate {
  protected vignettePreview: vignettePreview_template;
  protected defaultVignettePreview: vignettePreview_template;

  protected getTemplateHtml(): string {
    return /*html*/ `

                <div class="w-form w-form-large view-tag">

                ${this.getInactiveTagPopupHtml()}

                    <div class="form-header">
                        <div class="w-btn">
                            <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                        </div>
                        <h3 class="form-title" data-bind="text: name"></h3>
                        <div class="w-btn" style="min-width:110px;">
                            <button class="btn icon i-edit"
                                type="button"
                                data-bind="
                                    event: { click: onClickEdit },
                                    visible: canEditThisTag()
                                "
                            >
                                Edit Tag
                            </button>
                        </div>
                    </div>

                    <div class="w-form-body">
                        <div class="form-body">
                            <strong class="form-sub-title">Tag</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <!-- ko if: idBrand -->
                                    <dt>
                                        <span>Is Active</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: isActive"></span>
                                    </dd>
                                    <dt>
                                        <span>Available for use</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: isSelectable"></span>
                                    </dd>
                                    <!-- ko if: isBrandOwner() -->
                                        <dt class="full-width brand-indicator">
                                            <span data-bind="attr: { class: brandOwner().iconImage + ' dark square-icon brand-owner' }"></span>
                                            <div class="" data-bind="text: getBrandOwnerInfoText()"></div>
                                        </dt>
                                    <!-- /ko -->
                                    <!-- /ko -->
                                    <dt class="full-width">
                                        <span>Name</span>
                                    </dt>
                                    <dd class="full-width">
                                        <span data-bind="text: name"></span>
                                    </dd>

                                    <!-- ko if: referenceDescription() -->
                                    <dt class="full-width">
                                        <span>Reference Description</span>
                                    </dt>
                                    <dd class="full-width">
                                        <span data-bind="text: referenceDescription"></span>
                                    </dd>
                                    <!-- /ko -->

                                    <dt class="full-width">
                                        <span>Owner Backlink Page URL</span>
                                    </dt>
                                    <dd class="full-width">
                                        <span class="form-read"><a style="text-transform: none" target="_blank" data-bind="attr: { href : urlHubPage}, text : urlHubPage"></a></span>
                                    </dd>

                                    <dt>
                                        <span>Tag Type</span>
                                    </dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: tagType"></span>
                                        <!-- ko if: brandOwner -->
                                        <span data-bind="attr: { class: brandOwner().iconImage + ' dark square-icon brand-owner' }"></span>
                                        <!-- /ko -->
                                    </dd>

                                   <!-- ko if: idBrand -->
                                    <dt>
                                        <span>Date Created</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: dateCreated"></span>
                                    </dd>
                                    <!-- /ko -->

                                </dl>
                            </div>

                            <strong class="form-sub-title">Tag Color</strong>
                            <div class="form-group" data-bind="css: { 'default-value' : automaticDefault() || tagColor() === null}">
                                <dl class="double-list">
                                    <dt>
                                        <span>Tag Color</span>
                                    </dt>
                                    <dd class="no-cap">
                                        <!-- ko if: automaticDefault() || tagColor() === null -->
                                            <span data-bind="text: tagDefaults() && tagDefaults().tagColor ? tagDefaults().tagColor : 'None'" style="padding-right: 16px;"></span>
                                            <!-- ko if: tagDefaults() && tagDefaults().tagColor -->
                                                <div data-bind="style: { 'background-color': tagDefaults().tagColor }"
                                                    style="
                                                        height: calc(1.25rem - 2px);
                                                        width: calc(1.25rem - 2px);
                                                        border: 1px solid #d1d1d1;
                                                        border-radius: 10%;
                                                        display: inline-block;
                                                        position: absolute;
                                                        right: 0;
                                                        top: 11px;
                                                    "
                                                ></div>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                        <!-- ko ifnot: automaticDefault() || tagColor() === null -->
                                            <span data-bind="text: tagColor() ? tagColor() : 'None'" style="padding-right: 16px;"></span>
                                            <!-- ko if: tagColor() -->
                                                <div data-bind="style: { 'background-color': tagColor() }"
                                                    style="
                                                        height: calc(1.25rem - 2px);
                                                        width: calc(1.25rem - 2px);
                                                        border: 1px solid #d1d1d1;
                                                        border-radius: 10%;
                                                        display: inline-block;
                                                        position: absolute;
                                                        right: 0;
                                                        top: 11px;
                                                    "
                                                ></div>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    </dd>
                                </dl>
                            </div>

                            <strong class="form-sub-title">Image</strong>
                            <div class="form-group" data-bind="css: { 'default-value' : automaticDefault() || tagImage() === null}">
                                <!-- ko if: automaticDefault() || tagImage() === null -->
                                    <!-- ko if: tagDefaults().image -->
                                        <img data-bind="attr: { src: tagDefaults() && tagDefaults().image != null ? tagDefaults().image.url : '' }"  alt="Image" style="width: 50%;" />
                                    <!-- /ko -->
                                    <!-- ko ifnot: tagDefaults().image -->
                                        <span>No Image</span>
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- ko ifnot: automaticDefault() || tagImage() === null -->
                                    <!-- ko if: tagImage()  -->
                                        <img data-bind="attr: { src: tagImage()? tagImage().url : '' }"  alt="No Image" style="width: 50%;" />
                                    <!-- /ko -->
                                    <!-- ko ifnot: tagImage()  -->
                                        <span>No Image</span>
                                    <!-- /ko -->
                                <!-- /ko -->

                            </div>
                            <strong class="form-sub-title">Icon</strong>
                            <div class="form-group" data-bind="css: { 'default-value' : automaticDefault() || tagIconImage() === null}">
                                <!-- ko if: automaticDefault() || tagIconImage() === null -->
                                    <!-- ko if: tagDefaults().iconImage -->
                                    <img data-bind="attr: { src: tagDefaults() && tagDefaults().iconImage != null ? tagDefaults().iconImage.url : '' }"  alt="Image" style="width: 50%;" />
                                    <!-- /ko -->
                                    <!-- ko ifnot: tagDefaults().iconImage -->
                                        <span>No Icon</span>
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- ko ifnot: automaticDefault() || tagIconImage() === null -->
                                    <!-- ko if: tagIconImage() -->
                                    <img data-bind="attr: { src: tagIconImage() ? tagIconImage().url : '' }"  alt="No Image" style="width: 50%;" />
                                    <!-- /ko -->
                                    <!-- ko ifnot: tagIconImage() -->
                                    <span>No Icon</span>
                                    <!-- /ko -->
                                <!-- /ko -->
                            </div>
                            <strong class="form-sub-title">Banner</strong>
                            <div class="form-group" data-bind="css: { 'default-value' : automaticDefault() || tagBannerImage() === null}">
                                <!-- ko if: automaticDefault() || tagBannerImage() === null -->
                                    <!-- ko if: tagDefaults().bannerImage -->
                                    <img data-bind="attr: { src: tagDefaults() && tagDefaults().bannerImage != null ? tagDefaults().bannerImage.url : '' }"  alt="Image" style="width: 50%;" />
                                    <!-- /ko -->
                                    <!-- ko ifnot: tagDefaults().bannerImage -->
                                        <span>No Banner</span>
                                    <!-- /ko -->
                                <!-- /ko -->
                                <!-- ko ifnot: automaticDefault() || tagBannerImage() === null -->
                                    <!-- ko if: tagBannerImage() -->
                                    <img data-bind="attr: { src: tagBannerImage() ? tagBannerImage().url : '' }"  alt="No Image" style="width: 50%;" />
                                    <!-- /ko -->
                                    <!-- ko ifnot: tagBannerImage() -->
                                    <span>No Banner</span>
                                    <!-- /ko -->
                                <!-- /ko -->
                            </div>
                            <strong class="form-sub-title">Image Group</strong>
                            <div class="form-group">
                                <dl class="double-list" data-bind="css: { 'default-value' : automaticDefault() || tagImageGroup() === null}">
                                    <dd class="full-width no-cap">
                                        <!-- ko if: automaticDefault() || tagImageGroup() === null -->
                                            <span data-bind=" text: tagDefaults().imageGroup? imageGroupSummary(tagDefaults().imageGroup) : 'None' "></span>
                                        <!-- /ko -->
                                        <!-- ko ifnot: automaticDefault() || tagImageGroup() === null -->
                                            <span data-bind=" text: tagImageGroup? imageGroupSummary(tagImageGroup()) : 'None' "></span>
                                        <!-- /ko -->
                                    </dd>
                                </dl>
                            </div>

                            <!-- ko if: idBrand -->
                                <strong class="form-sub-title">Tag Video</strong>
                                <div class="form-group row" style="margin-bottom: .5rem;" >
                                    <label class="form-label">Tag Video</label>
                                </div>
                                <div class="form-group img-group tag-video">
                                    <!-- ko if: tagVideo -->
                                        <button class="btn-form icon i-video" data-bind="event: { click: onClickWatchVideo }">Watch Video</button>
                                        <span data-bind="text: tagVideoTitle"></span>
                                        <div class="icon-img icon i-video-2 ">
                                            <img data-bind="attr: { src: tagVideoThumbnailURL, alt: tagVideoTitle }" />
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko if: !tagVideo -->
                                        <span>No Video</span>
                                    <!-- /ko -->
                                </div>
                            <!-- /ko -->
                        </div>
                        <div class="form-body">
                            <strong class="form-sub-title">SEO Description</strong>

                            <div class="form-group seo-description">

                                <dl class="double-list" data-bind="css: { 'default-value' : automaticDefault() || seoDescription() === null}">
                                    <dt class="full-width">
                                        <span>SEO Description</span>
                                    </dt>
                                    <dd class="full-width no-cap">
                                        <!-- ko if: automaticDefault() || seoDescription() === null -->
                                            <span data-bind=" html: tagDefaults().shortDescription || 'None' "></span>
                                        <!-- /ko -->
                                        <!-- ko ifnot: automaticDefault() || seoDescription() === null -->
                                            <span data-bind=" text: seoDescription || 'None'"></span>
                                        <!-- /ko -->
                                    </dd>
                                </dl>

                            </div>

                            <!-- ko if: idBrand -->
                            <strong class="form-sub-title">Review Score</strong>

                            <div class="form-group seo-description">
                                <dl class="double-list">
                                    <dt class="full-width"><span>Review Score</span></dt>

                                    <!-- ko if: !reviewScoreIsUnderEmbargo() -->
                                    <dd class="full-width no-cap">
                                        <span data-bind=" text: reviewScore() != null ? reviewScore : 'None'"></span>
                                    </dd>
                                    <!-- /ko -->

                                    <!-- ko if: !embargoPermissions().read && reviewScoreIsUnderEmbargo() -->
                                    <div data-bind="text : (reviewScoreEmbargoEndDate() ? 'Score Under Embargo Until ' + reviewScoreEmbargoEndDate() : '' ) " ></div>
                                    <!-- /ko -->

                                    <!-- ko if: embargoPermissions().read && reviewScoreIsUnderEmbargo() -->
                                    <dd class="full-width no-cap"><span data-bind=" text: reviewScore() != null ? reviewScore : 'None'"></span></dd>
                                    <div data-bind="text : (reviewScoreEmbargoEndDate() ? 'Score Under Embargo Until ' + reviewScoreEmbargoEndDate() : '' ) " ></div>
                                    <!-- /ko -->
                                </dl>
                            </div>
                            <!-- /ko -->


                            <strong class="form-sub-title">Affiliates</strong>

                            <div class="form-group" data-bind="css: { 'default-value' : automaticDefault()}">
                                <dl class="double-list">

                                    <!-- ko if: automaticDefault() || affiliateLinks() === null -->
                                        <!-- ko foreach: tagDefaults().affiliateLinks -->
                                            <dt class="full-width" data-bind="visible: !$data.countryCode ?? true">
                                                <span data-bind="text: type"></span>
                                            </dt>
                                            <dd class="full-width no-cap" data-bind=" visible: !$data.countryCode ?? true">
                                                <span data-bind="text: value"></span>
                                            </dd>
                                        <!-- /ko -->

                                    <!-- /ko -->
                                    <!-- ko ifnot: (automaticDefault() || affiliateLinks() === null) -->
                                        <!-- ko foreach: affiliateLinks -->
                                        <!-- ko if: $data.option === null || $data.option === ""-->
                                        <dt class="full-width" data-bind="visible: !$data.countryCode ?? true">
                                            <span data-bind="text: type"></span>
                                        </dt>
                                        <dd class="full-width no-cap" data-bind=" visible: !$data.countryCode ?? true">
                                            <span data-bind="text: value"></span>
                                        </dd>
                                        <!-- /ko -->
                                        <!-- /ko -->

                                    <!-- /ko -->
                                </dl>
                            </div>

                            <strong class="form-sub-title">Advanced Option Links</strong>

                            <div class="form-group affiliate-list" data-bind="css: { 'default-value' : automaticDefault()}">
                                <div class="" data-bind="visible: showContainsString || hasStreamRentBuyLinks || defaultStreamRentBuyLinks">
                                  ${this.getAffiliateLinkOptionsCountHtml()}
                                </div>
                                <div class="affiliate-options-list">
                                <!-- ko foreach: affiliateOptionLinks -->
                                  ${this.getAffiliateOptionsLinksHtml()}
                                <!-- /ko -->
                                </div>
                            </div>

                            <strong class="form-sub-title">Description</strong>

                            <div class="form-group form-group-textarea">

                                <dl class="double-list" data-bind="css: { 'default-value' : automaticDefault()}">
                                    <dt class="full-width">
                                        <span>Description</span>
                                    </dt>
                                    <dd class="full-width no-cap">
                                        <!-- ko if: automaticDefault() || reviewText() === null -->
                                            <span id="product_review_text" data-bind=" html: tagDefaults().description"></span>
                                        <!-- /ko -->
                                        <!-- ko ifnot: automaticDefault() || reviewText() === null -->
                                            <span id="product_review_text" data-bind=" html: reviewText"></span>
                                        <!-- /ko -->
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>

                    <div class="w-form-body">
                        <strong class="form-sub-title">Vignette</strong>
                        <div class="form-body">
                            <div class="form-group">
                                <!-- ko if: automaticDefault() || vignette() === null -->
                                    <div class="form-group row" data-bind="visible: tagDefaults().vignette != null">
                                        ${this.defaultVignettePreview.getHtmlBuild()}
                                    </div>
                                    <div class="form-group row" data-bind="visible: tagDefaults().vignette == null">
                                        None
                                    </div>
                                <!-- /ko -->
                                <!-- ko ifnot: automaticDefault() || vignette() === null -->
                                    <div class="form-group row" data-bind="visible: vignette() != null">
                                        ${this.vignettePreview.getHtmlBuild()}
                                    </div>
                                    <div class="form-group row" data-bind="visible: vignette() == null">
                                        None
                                    </div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>

                <!-- ko if: providers().length > 0 && isBrandOwner() || (!idBrand() && brandOwner()) -->
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <strong class="form-sub-title">Providers</strong>
                            <!-- ko foreach: providers -->
                                <!-- ko if: idProviderReference -->
                                    <div class="form-group">
                                        <label data-bind="text: providerName" class="form-label"></label>
                                        <p data-bind="text: idProviderReference"></p>
                                    </div>
                                <!-- /ko -->
                                <!-- ko ifnot: idProviderReference -->
                                    <div class="form-group">
                                        <label data-bind="text: providerName" class="form-label"></label>
                                        <p>None</p>
                                    </div>
                                <!-- /ko -->
                            <!-- /ko -->
                        </div>
                    </div>
                <!-- /ko -->

                    <div class="w-form-body">
                        <strong class="form-sub-title">Specifications<span data-bind="if: hasDefaultDataAvailable()">*</span></strong>
                        <div class="form-body">
                            <!-- ko if: hasDefaultDataAvailable() -->
                            <div class="form-group">
                                <small>* Has default data available</small>
                            </div>
                            <!-- /ko -->
                            <div class="form-group">
                                <table class="list-action full-width">
                                    <thead>
                                        <tr style="background-color: #8a8a8a">
                                            <th>
                                                <span>Field Name</span>
                                            </th>
                                            <th>
                                                <span>Type</span>
                                            </th>
                                            <th data-bind="visible: permissions()['vignettes'].read">
                                                <span>Reference</span>
                                            </th>
                                            <!-- ko if: idBrand -->
                                            <th>
                                                <span>Value</span>
                                            </th>
                                            <!-- /ko -->
                                            <!-- ko ifnot: idBrand -->
                                            <th>
                                                <span>Default</span>
                                            </th>
                                            <!-- /ko -->
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: { data: specifications, as: 'spec' }">
                                        <tr data-bind="css: { 'third-party-spec' : spec.isProvider }">
                                            <td>
                                                <span  data-bind="text: $parent.getSpecLabel(spec),css: { 'icon i-cloud' : spec.isProvider }"></span>
                                            </td>

                                            <td>
                                                <span data-bind="text: dataType"></span>
                                            </td>
                                            <td class="align-center" data-bind="visible: $parent.permissions()['vignettes'].read">
                                                <span data-bind="text: reference ? '[[' + reference + ']]' : ''"></span>
                                            </td>

                                            <!-- ko if: $parent.idBrand() && !isDefault -->
                                            <td class="value d-flex">
                                                <div class="only-icon icon i-circle"></div>
                                                <!-- ko if: dataType == 'tags' -->
                                                <div>
                                                <!-- ko if: value.length > 0 -->
                                                    <ul  class="list-tag" data-bind="foreach: value">
                                                        <li class="item-tag">
                                                            <span class="form-tag" data-bind="text: name + (type != null ? ' ' + formattedTagTypeAndDataset : '')"></span>
                                                        </li>
                                                    </ul>
                                                <!-- /ko -->
                                                </div>
                                                <!-- /ko -->
                                                <!-- ko if: dataType == 'tag' -->
                                                    <div>
                                                        <span data-bind="text: (value && value[0] ? value[0].name + ' ' + value[0].formattedTagTypeAndDataset : '')"></span>
                                                    </div>
                                                <!-- /ko -->
                                                <!-- ko ifnot: dataType == 'tag' || dataType == 'tags' -->
                                                    <div>
                                                    <!-- ko if: dataType == 'images' && Array.isArray(value) && value.length > 0 -->
                                                        <span data-bind="text: value.length + ' images in group'"></span>
                                                    <!-- /ko -->
                                                    <!-- ko ifnot: dataType == 'images' -->
                                                        <span data-bind="text: value"></span>
                                                    <!-- /ko -->
                                                    </div>
                                                <!-- /ko -->
                                            </td>
                                            <!-- /ko -->
                                            <!-- ko if: !$parent.idBrand() || isDefault -->
                                            <td class="default-value d-flex">
                                                <div class="only-icon icon i-circle"></div>
                                                <!-- ko if: spec.dataType == 'tags' && $parent.getSpecDefault(spec.dataType, spec.fieldId) -->
                                                    <div>
                                                        <ul class="list-tag" data-bind="foreach: {data: $parent.getSpecDefault(spec.dataType, spec.fieldId), as: 'defVal' }">
                                                            <li class="item-tag">
                                                                <span class="form-tag" data-bind="text: defVal"></span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                <!-- /ko -->
                                                <!-- ko ifnot: spec.dataType == 'tags' && $parent.getSpecDefault(spec.dataType, spec.fieldId) -->
                                                    <div>
                                                        <span data-bind="html: $parent.getSpecDefault(spec.dataType, spec.fieldId)"></span>
                                                    </div>
                                                <!-- /ko -->
                                            </td>
                                            <!-- /ko -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                `;
  }

  protected getAffiliateLinkOptionsCountHtml(): string {
    return /* html */ `
      <label class="form-label" data-bind="html: affiliateOptionsString"></label>
    `;
  }

  protected getAffiliateOptionsLinksHtml(): string {
    return /* html */ `
      <!-- ko ifnot: $data.option === null || $data.option === ""-->
      <div class="form-row" data-bind="visible: $data.option ?? true">
        <label data-bind="text: type" class="form-label" style="font-weight:300; margin-bottom:.75rem;"></label>
        <div style="font-size:1.1rem;font-weight:700;letter-spacing: .75px;">
          <span class="form-read"><a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id, href : value}, text : value.substr(0,30)" id="site-view202761"></a></span>
          <span class="form-read" data-bind="text: $data.option ? $data.option : ''"> </span>
          <span class="form-read" data-bind="text: $data.countryCode ? $data.countryCode : ''"> </span>
        </div>
      </div>
      <!-- /ko -->
      <!--<div data-bind="text: ko.toJSON($data, null, 2)"></div>-->
    `;
  }

  protected getInactiveTagPopupHtml(): string {
    return /* html */ `
            <div id="inactive-tag-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div id="inactive-tag-dialog-form" class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Tag Inactive</h3>
                            <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This tag is inactive for the current brand</p>
                                <p class="form-text">Activate the tag to continue</p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancel }" class="btn">Go Back</button>
                            <button type="button" data-bind="event: { click: onClickActivateTag }" class="btn highlight">Activate</button>
                        </div>
                    </div>
                </div>
            </div>
  `;
  }

  protected initPartial(): void {
    this.vignettePreview = new vignettePreview_template(
      "vignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );
    this.defaultVignettePreview = new vignettePreview_template(
      "defaultVignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );
  }

  protected getTemplateName(): string {
    return "configTagsView_template";
  }

  protected buildViewModel(): any {
    let huit_neuf_this = this;

    return {
      id: ko.observable(""),
      idBrand: ko.observable(),
      name: ko.observable(""),
      idReference: ko.observable(null),
      referenceDescription: ko.observable(null),
      slug: ko.observable(""),
      urlHubPage: ko.observable(null),
      tagColor: ko.observable(),
      tagVideoThumbnailURL: ko.observable(null),
      tagVideoURL: ko.observable(null),
      tagVideoTitle: ko.observable(null),
      tagVideo: ko.observable(null),
      tagImage: ko.observable(""),
      tagIconImage: ko.observable(""),
      tagBannerImage: ko.observable(""),
      tagImageGroup: ko.observable(""),
      tagType: ko.observable(""),
      ...TagDefaultsHelper.viewModelProperties,
      isBrandOwner: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().idBrandOwner() &&
          huit_neuf_this.getTemplateViewModel().idBrandOwner() ==
            huit_neuf_this.getTemplateViewModel().idBrand()
        );
      }),
      brandOwner: ko.observable(null),
      automaticDefault: ko.pureComputed(
        () =>
          !huit_neuf_this.getTemplateViewModel().idBrand() ||
          huit_neuf_this.getTemplateViewModel().isBrandOwner()
      ),
      idBrandOwner: ko.observable(""),
      specDefaults: ko.observableArray(),
      providers: ko.observableArray(),
      specifications: ko.observableArray(),
      description: ko.observable(""),
      isSelectable: ko.observable(""),
      isActive: ko.observable(""),
      dateCreated: ko.observable(""),
      affiliateLinks: ko.observableArray([]),
      affiliateOptionLinks: ko.observableArray([]),
      affiliateOptionsString: ko.observable(null),
      showContainsString: ko.observable(false),
      reviewText: ko.observable(),
      seoDescription: ko.observable(),
      reviewScore: ko.observable(null),
      reviewScoreIsUnderEmbargo: ko.observable(false),
      reviewScoreEmbargoEndDate: ko.observable(null),
      vignette: ko.observable(null),
      permissions: ko.observableArray(
        this.initPermissions(["vignettes", "tag_type_edit_owned", "article_edit_embargo",])
      ),
      canEditThisTag: ko.observable(false),
      onClickWatchVideo: function () {
        huit_neuf_this.onClickWatchVideo();
      },
      streamRentBuyLinks: ko.pureComputed(() => {
        // optionable links are automatically populated, and have an option of stream, rent, or buy set
        return huit_neuf_this
          .getTemplateViewModel()
          .affiliateLinks()
          .filter(streamRentBuyFilter);
      }),
      hasStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().streamRentBuyLinks().length > 0
        );
      }),
      defaultStreamRentBuyLinks: ko.pureComputed(() => {
        // optionable links are automatically populated, and have an option of stream, rent, or buy set
        const vm = huit_neuf_this.getTemplateViewModel();

        return vm.tagDefaults() && vm.tagDefaults().affiliateLinks
          ? vm.tagDefaults().affiliateLinks.filter(streamRentBuyFilter)
          : [];
      }),
      defaultsHaveStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().defaultStreamRentBuyLinks()
            .length > 0
        );
      }),
      buildAffiliateOptionsString: function () {
        let optionNames = [];
          const streamLinks = TagDefaultsHelper.getAffiliateLinks(huit_neuf_this.getTemplateViewModel());
          for (let sl in streamLinks) {
            if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length == 0) {
              optionNames.push({name: streamLinks[sl].option, count: 1});
            } else if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length >= 0) {
              optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase())[0].count++;
            }
          }

          if (optionNames.length <= 0) {
            huit_neuf_this.getTemplateViewModel().showContainsString(false);
            return "";
          }

          huit_neuf_this.getTemplateViewModel().showContainsString(true);

          let optionString = "Contains ";

          for (let on in optionNames) {
            optionString += "<span style=\"padding-bottom: 0;transform: none;\">" + optionNames[on].count + " " + optionNames[on].name + " / </span>";
          }

          return optionString.slice(0, optionString.length - 9) + "</span> Option Links";
      },
      setAffiliateOptionLinks: function () {

        if (huit_neuf_this.getTemplateViewModel().useTagDefaults().affiliateLinks || huit_neuf_this.getTemplateViewModel().isBrandOwner()) {
          huit_neuf_this.getTemplateViewModel().affiliateOptionLinks(huit_neuf_this.getTemplateViewModel().tagDefaults().affiliateLinks);
        } else {
          huit_neuf_this.getTemplateViewModel().affiliateOptionLinks(huit_neuf_this.getTemplateViewModel().affiliateLinks());
        }

      },
      onClickEdit: function (data, event) {
        huit_neuf_this.onClickEdit(data.id());
      },
      onClickCancel: function (data, event) {
        huit_neuf_this.onClickCancel();
      },
      onClickViewTagImage: function (data, event) {
        huit_neuf_this.onClickViewTagImage();
      },
      onClickCloseTagImage: function (data, event) {
        huit_neuf_this.onClickCloseTagImage();
      },
      onClickActivateTag: function (data, event) {
        huit_neuf_this.onClickActivateTag();
      },
      getBrandOwnerInfoText: () =>
        TagDefaultsHelper.getBrandOwnerInfoText(
          huit_neuf_this.getTemplateViewModel().brandOwner()
        ),
      hasDefaultDataAvailable: ko.pureComputed(() => {
        const vm = huit_neuf_this.getTemplateViewModel();
        return (
          vm.specDefaults().length > 0 &&
          vm.idBrand() &&
          vm.idBrandOwner() &&
          !vm.isBrandOwner()
        );
      }),
      embargoPermissions : ko.pureComputed(() => {
        const vm = huit_neuf_this.getTemplateViewModel();
        const permissions = vm.permissions()["article_edit_embargo"];
        const { read = false, write = false } = permissions || {};
        return { read, write };
      }),
      hasSpecDefault: function (idField: number): boolean {
        // use to signify the presence of a default
        return (
          huit_neuf_this
            .getTemplateViewModel()
            .specDefaults()
            .findIndex((specDefault) => idField === specDefault.fieldId) >= 0
        );
      },
      getSpecDefault: function (
        dataType: string,
        idField: number
      ): string | null {
        const record = huit_neuf_this
          .getTemplateViewModel()
          .getSpecDefaultData(idField);

        if (!record || !record.value) {
          return "";
        }

        if (dataType === "tag") {
          return record.value && record.value[0]
            ? `${record.value[0].name} ${record.value[0].formattedTagTypeAndDataset}`
            : "";
        } else if (dataType === "tags") {
          return record.value && record.value.length > 0
            ? record.value.map((rec) =>
                rec.type
                  ? `${rec.name} ${rec.formattedTagTypeAndDataset}`
                  : rec.name
              )
            : [];
        } else if (dataType === "images") {
            let msg = Array.isArray(record.value) && record.value.length > 0
                ? record.value.length + " images in group"
                : '';

            return msg;
        } else {
          return record.value;
        }
      },
      getSpecDefaultData: function (idField: number): string | null {
        const defaultIndex = huit_neuf_this
          .getTemplateViewModel()
          .specDefaults()
          .findIndex((specDefault) => idField === specDefault.fieldId); // defaults come back with fieldId, not idField

        if (defaultIndex < 0) {
          return null;
        }

        return huit_neuf_this.getTemplateViewModel().specDefaults()[
          defaultIndex
        ];
      },
      getSpecLabel: (spec: any): string => {
        if (
          !huit_neuf_this.getTemplateViewModel().idBrand() ||
          spec.isDefault
        ) {
          const defaultSpec = huit_neuf_this
            .getTemplateViewModel()
            .getSpecDefaultData(spec.fieldId);
          if (defaultSpec) {
            // might have default set, but no default spec yet.
            spec = defaultSpec;
          }
        }

        if (!spec.ratingScale) {
          return spec.label;
        } else {
          return spec.label + " / " + spec.ratingScale;
        }
      },

      imageGroupSummary: (imageGroup: any): string =>
        TagDefaultsHelper.imageGroupSummary(imageGroup),
    };
  }

  public setupCanEditThisTag = () => {
    const vm = this.getTemplateViewModel();

    vm.canEditThisTag(
      userCanEditOwnedTagType(
        this.caller.vnAppZone,
        vm.permissions(),
        vm.idBrand(),
        vm.idBrandOwner()
      )
    );
  };

  public setupUseTagDefaults(tag = null): void {
    const vm = this.getTemplateViewModel();

    return TagDefaultsHelper.setupUseTagDefaults(
      vm,
      null,
      null,
      null,
      null,
      tag
    );
  };

  public onClickWatchVideo() {
    let videoURL = this.getTemplateViewModel().tagVideoURL();
    if (videoURL) {
      window.open(videoURL, "_blank");
    }
  }

  public setTagVideo(video) {
    this.getTemplateViewModel().tagVideo(video);
    if (video) {
      this.getTemplateViewModel().tagVideoURL(video.url);
      this.getTemplateViewModel().tagVideoThumbnailURL(video.thumbnail.url);
      this.getTemplateViewModel().tagVideoTitle(video.title);
    }
  }

  public onClickEdit(id) {
    this.caller.edit(id);
  }

  public onClickCancel() {
    this.caller.cancel();
  }

  public setId(id): void {
    this.getTemplateViewModel().id(id);
  }

  public setName(name): void {
    this.getTemplateViewModel().name(name);
  }

  public setIdReference(idReference): void {
    this.getTemplateViewModel().idReference(idReference);
  }

  public setReferenceDescription(referenceDescription): void {
    this.getTemplateViewModel().referenceDescription(referenceDescription);
  }

  public setTagType(tagType): void {
    this.getTemplateViewModel().tagType(tagType);
  }

  public setSlug(name): void {
    this.getTemplateViewModel().slug(name);
  }

  public setUrlHubPage(name): void {
    this.getTemplateViewModel().urlHubPage(name);
  }

  public setDescription(description): void {
    this.getTemplateViewModel().description(description);
  }

  public setIsSelectable(isSelectable): void {
    this.getTemplateViewModel().isSelectable(isSelectable);
  }

  public setIsActive(isActive): void {
    this.getTemplateViewModel().isActive(isActive);
  }

  public setBrandOwner(brandOwner: emaki_brand | null): void {
    this.getTemplateViewModel().brandOwner(brandOwner);
    this.setIdBrandOwner(brandOwner ? brandOwner.id : null);
  }

  public setIdBrandOwner(brandOwner: number | null): void {
    this.getTemplateViewModel().idBrandOwner(brandOwner);
  }

  public setDateCreated(dateCreated): void {
    this.getTemplateViewModel().dateCreated(dateCreated);
  }

  public setIdBrand(idBrand): void {
    this.getTemplateViewModel().idBrand(idBrand);
  }

  public setPermissions(permissions) {
    this.getTemplateViewModel().permissions(permissions);
  }

  public setProviders(providers): void {
    this.getTemplateViewModel().providers(providers);
  }

  public setSpecifications(specifications) {
    this.getTemplateViewModel().specifications(specifications);
  }

  public setSpecDefaults(specDefaults) {
    this.getTemplateViewModel().specDefaults(specDefaults);
  }

  private getSpecs(tagFields, values) {
    let specs: specification[] = [];

    for (let i = 0; i < tagFields.length; i++) {
      let fieldDataType = tagFields[i].dataType;
      let dataType: dataType | null = null;
      let fieldData: fieldData | null = null;
      if (fieldDataType === SPEC_TYPE_TEXT.name) {
        dataType = SPEC_TYPE_TEXT;
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue.value : "";
      } else if (fieldDataType === SPEC_TYPE_DATE.name) {
        dataType = SPEC_TYPE_DATE;
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue.value : "";
      } else if (fieldDataType === SPEC_TYPE_TAG.name) {
        dataType = SPEC_TYPE_TAG;
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue
          ? { idField: tagFields[i].id, value: fieldValue.value[0] }
          : {};
      } else if (fieldDataType === SPEC_TYPE_TAGS.name) {
        dataType = SPEC_TYPE_TAGS;
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue && fieldValue.value ? fieldValue.value : [];
      }
      specs.push({
        fieldId: tagFields[i].id,
        label: tagFields[i].label,
        data: fieldData,
        restriction: tagFields[i].restriction,
        type: dataType,
        isSelected: true,
        isAdded: false,
        isForcedOverwrite: tagFields[i].isForcedOverwrite,
      });
    }

    return specs;
  }

  protected formatNumberWithCommas(value) {
    if (value) {
      const cleanValueString = value
        .toString()
        .replace(/[$]/g, "")
        .replace(/,/g, "");
      const cleanValue = parseFloat(cleanValueString);
      const decimalPlaces = (cleanValue.toString().split(".")[1] || "").length;
      // Format the cleaned number with commas
      return cleanValue.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      });
    }
    // Remove any commas and dollar signs from the input
  }

  public setTagDefaults(tagDefaults: any) {
    this.getTemplateViewModel().tagDefaults(tagDefaults);
    this.defaultVignettePreview.setVignette(
      tagDefaults.vignette ? tagDefaults.vignette : null
    );
  }

  public setTagColor(tagColor) {
    this.getTemplateViewModel().tagColor(tagColor);
  }

  public setTagImage(tagImage) {
    this.getTemplateViewModel().tagImage(tagImage);
  }

  public setTagIconImage(tagIconImage) {
    this.getTemplateViewModel().tagIconImage(tagIconImage);
  }

  public setTagBannerImage(tagBannerImage) {
    this.getTemplateViewModel().tagBannerImage(tagBannerImage);
  }

  public setTagImageGroup(tagImageGroup) {
    this.getTemplateViewModel().tagImageGroup(tagImageGroup);
  }

  public setSeoDescription(seoDescription) {
    this.getTemplateViewModel().seoDescription(seoDescription);
  }

  public setReviewScore(reviewScore) {
    this.getTemplateViewModel().reviewScore(reviewScore);
  }

  public setVignette(vignette) {
    this.getTemplateViewModel().vignette(vignette);
    this.vignettePreview.setVignette(vignette);
  }

  public setIndexedValues(tag = null, specsValues = [], specDefaults = []) {
    this.vignettePreview.setIndexedValues(tag, specsValues, specDefaults);
    this.defaultVignettePreview.setIndexedValues(
      tag,
      specsValues,
      specDefaults
    );
  }

  public setProductText(productText) {
    this.getTemplateViewModel().reviewText(productText);
  }

  public setAffiliateLinks(affiliateLinks: null | AffiliateLink[]) {
    this.getTemplateViewModel().affiliateLinks(
      affiliateLinks === null ? null : [...affiliateLinks]
    );
  }

  protected onClickViewTagImage() {
    let tagImageElement = document.getElementById("tagImage");
    tagImageElement!.classList.add("is-viewing");
  }

  protected onClickCloseTagImage() {
    let tagImageElement = document.getElementById("tagImage");
    tagImageElement!.classList.remove("is-viewing");
  }

  protected onClickActivateTag() {
    document.getElementById('inactive-tag-dialog-form').classList.toggle('loading');
    this.caller.activateTagById();
  }

  public toggleInactiveTagPopupVisibility() {
    document.getElementById('inactive-tag-dialog').classList.toggle('is-visible');
  }

  setReviewScoreEmbargoEndDate(date?: string){
    this.getTemplateViewModel().reviewScoreEmbargoEndDate(date);
  }

  setReviewScoreIsUnderEmbargo(val: boolean){
    this.getTemplateViewModel().reviewScoreIsUnderEmbargo(val);
  }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagsView_template.ts